import { render, staticRenderFns } from "./EntityPickerCreate.vue?vue&type=template&id=454c4d08"
import script from "./EntityPickerCreate.vue?vue&type=script&lang=js"
export * from "./EntityPickerCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports